import React from "react";
import { useColorBar } from "../CustomHooks";
import { calculatePosition, generateAxisValues } from "../utils";
import ColorbarSetRange from "./ColorBarSetRange";
import { getColorbarGradientClassName } from "./colorbarConstants";
import "./colorBar.css";

const formatTickValue = (num, range) => {
  if (range < 0.1 && range !== 0) return num.toFixed(3);
  if (range < 1 && range !== 0) return num.toFixed(2);
  return num.toFixed(1);
};

export const CustomColorBar = ({
  gradient,
  category,
  subcategory,
  unit,
  dataMin,
  dataMax,
  isVisible,
}) => {
  const { max, min } = useColorBar(category, subcategory);
  const generatedNumbers = generateAxisValues(min || dataMin, max || dataMax);

  if (!isVisible || !generatedNumbers?.length) {
    return null;
  }

  return (
    <div className="colorbar-view">
      <ColorbarSetRange
        category={category}
        subcategory={subcategory}
        defaultMax={parseFloat(dataMax?.toFixed(2))}
        defaultMin={parseFloat(dataMin?.toFixed(2))}
        colorbarMin={min}
        colorbarMax={max}
      />
      <ColorBarComponent
        generatedNumbers={generatedNumbers}
        min={generatedNumbers[0]}
        max={generatedNumbers[generatedNumbers.length - 1]}
        shiftUp={2}
        label={unit}
        gradient={gradient}
      />
    </div>
  );
};

export const ColorBarComponent = ({
  generatedNumbers,
  min,
  max,
  shiftUp,
  label,
  gradient,
  className,
}) => {
  const range = max - min;
  const gradientClassName = className || getColorbarGradientClassName(gradient);

  if (!generatedNumbers) return null;

  return (
    <div className="colorbar-card">
      <div className={gradientClassName}>
        {generatedNumbers.map((num, index) => {
          const tickTop = Math.max(
            0,
            Math.min(100, 100 - calculatePosition(num, min, max)),
          );
          return (
            <div
              key={index}
              className="colorbar-tick"
              style={{ top: `${tickTop}%` }}
            >
              <p className="colorbar-tick__label">
                {formatTickValue(num, range)}
              </p>
            </div>
          );
        })}
      </div>

      {label != null && label !== "" && (
        <div className="colorbar-unit-label">
          {typeof label === "function" ? label() : label}
        </div>
      )}
    </div>
  );
};

export default ColorBarComponent;
